__webpack_require__.p = "/bitrix/components/summit/react.calculator/source/dist/";